import React, { FunctionComponent } from "react";
import { Box } from "@mui/material";

import { BarDrawerHeader } from "../../../drawer";
import { COLORS } from "../../../consts";

import { SidebarToggleButtonProps } from "./types";

export const SidebarToggleButton: FunctionComponent<
  SidebarToggleButtonProps
> = ({ isOpen, close, open, collapsedWidth, expandedWidth }) => (
  <BarDrawerHeader data-testid="drawer-header">
    <Box
      component="div"
      sx={{
        position: "fixed",
        border: `1px solid ${COLORS.Romance}`,
        borderRadius: "100%",
        height: 30,
        width: 30,
        zIndex: 9999,
        left: isOpen ? expandedWidth - 18 : collapsedWidth - 16,
        top: 18,
        backgroundColor: COLORS.white,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
      }}
      onClick={isOpen ? close : open}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (isOpen) {
            close();
          } else {
            open();
          }
        }
      }}
      role="button"
      tabIndex={0}
      aria-label={isOpen ? "Close sidebar" : "Open sidebar"}
    >
      <div
        data-testid="sidebar-arrows"
        className={`sidebar-arrows ${
          isOpen ? "sidebar-arrows--open" : "sidebar-arrows--closed"
        }`}
      >
        <div className="arrow" />
        <div className="arrow_2" />
      </div>
    </Box>
  </BarDrawerHeader>
);
